import { Project } from "../models"

export const ACTION_TYPES = {
    FETCH_SUCCESS: "FETCH_PROJECT_SUCCESS" as const,
    FETCH: "FETCH_PROJECT" as const,

}

export type Actions =
    | { type: typeof ACTION_TYPES.FETCH_SUCCESS, payload: Project }
    | { type: typeof ACTION_TYPES.FETCH, payload: string }




// WEBPACK FOOTER //
// ./src/state/project/actions/types.ts